import { Component } from '@angular/core';

@Component({
  selector: 'app-unverified-email',
  templateUrl: './unverified-email.component.html',
  styleUrls: ['./unverified-email.component.scss']
})
export class UnverifiedEmailComponent {

}
